import { CaptionedImageBlock, CharBlock, ImageChooserBlock } from "graphql/generated-types";
import Image from "next/image";
import React from "react";

const CaptionedImageBlock = ({ block }: { block: CaptionedImageBlock }) => {
	return (
		<div className="container grid-cols-3 lg:grid">
			<Image
				className="w-full col-span-2"
				src={block.image?.rendition?.url!}
				alt={block.image?.rendition?.image.title!}
				width={615}
				height={600}
			/>
			{block.caption && (
				<div
					className="col-span-2 row-start-2 mt-2 text-sm leading-tight caption lg:mt-3"
					dangerouslySetInnerHTML={{ __html: block.caption }}
				/>
			)}
		</div>
	);
};

export default CaptionedImageBlock;
